import { render, staticRenderFns } from "./SystemUserPermissionTreeView.vue?vue&type=template&id=a4deec20&scoped=true"
import script from "./SystemUserPermissionTreeView.vue?vue&type=script&lang=js"
export * from "./SystemUserPermissionTreeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4deec20",
  null
  
)

export default component.exports